import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';
import { themeGet } from 'ravenjs/utils/theme';

const SearchInputContainer = styled(Box)`
    align-items: stretch;
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    line-height: 1.5;
    margin: 0;
    max-width: ${props => props.maxWidth};
    min-height: 36px;
    padding: 0;
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    width: 100%;
    ${({ focused, theme }) =>
        focused && {
            ...themeGet('effects.inputFocus')({ theme })['&:focus'],
        }};
    /**
     * Add in some focus effects
     */
    ${themeGet('effects.inputFocus')};
    /**
     * Add styles for disabled and read-only
     */
    ${({ disabled }) =>
        disabled && {
            backgroundColor: '#e1e5e9 !important',
            borderColor: 'transparent !important',
            boxShadow: 'none !important',
            cursor: 'not-allowed',
            userSelect: 'none',
        }};
    ${({ borderColor }) =>
        borderColor && {
            borderColor,
        }};
`;

export default SearchInputContainer;
